import { render, staticRenderFns } from "./otaDetail.vue?vue&type=template&id=6895ef9a&scoped=true"
import script from "./otaDetail.vue?vue&type=script&lang=js"
export * from "./otaDetail.vue?vue&type=script&lang=js"
import style0 from "./otaDetail.vue?vue&type=style&index=0&id=6895ef9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6895ef9a",
  null
  
)

export default component.exports